import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { IAppState } from '../../store/state';
import * as CoreActions from '../../store/actions';

/**
 * Resolve o tenant a partir do PRIMEIRO SEGMENTO da URL (rota `:tenant`, ver
 * app-routing.module.ts) — confirmado como padrão multitenant real do app em
 * https://dev-cliente.affix.com.br/{tenantSlug}/ (ex.: `affixbeneficios`),
 * bem diferente do portal-multiempresas-frontend/v1 (subdomínio).
 *
 * Dispara o carregamento dos parâmetros da Administradora e só libera a
 * navegação depois que o boot do tenant terminar (sucesso OU erro) — evita
 * renderizar a tela de login antes do tema (CSS vars) ser aplicado.
 */
@Injectable({
  providedIn: 'root',
})
export class TenantResolver implements Resolve<boolean> {
  constructor(private store: Store<IAppState>, private actions$: Actions) {}

  resolve(route: ActivatedRouteSnapshot): Observable<boolean> {
    const tenantSlug = route.paramMap.get('tenant');
    if (!tenantSlug) {
      return of(true);
    }

    this.store.dispatch(CoreActions.loadAdministradoraAttempt({ tenantSlug }));

    return this.actions$.pipe(
      ofType(CoreActions.loadAdministradoraSuccess, CoreActions.loadAdministradoraError),
      take(1),
      map(() => true)
    );
  }
}
